import { Component, OnInit, ViewChild } from '@angular/core';
import { UsuarioService } from '../services/usuario.service';
import { ListadoUsuarios } from '../models/viewmodels/listadoUsuarios';
import { RolViewModel } from '../models/viewmodels/rolViewModel';
import { UsuarioViewModel } from '../models/viewmodels/usuarioViewModel';
import { FormControl } from '@angular/forms';
import { DoubleBounceComponent } from '../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../shared/custom-alert/custom-alert.component';
import { Router } from '@angular/router'

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss'],
})
export class UsuariosComponent implements OnInit {
  query = new FormControl();
  pagina: number = 0;
  cantidadPorPagina: number = 20;
  listado: ListadoUsuarios = null;
  paginas: number = 0;
  isLoading = true;
  usuario: UsuarioViewModel;
  display: boolean = false;

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;
  
  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private usuarioService: UsuarioService, private router:Router) {
    this.listado = new ListadoUsuarios();
    this.listado.usuarios = new Array<UsuarioViewModel>();
   }

  ngOnInit() {
    this.obtenerUsuarios();
    this.query.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(term => {
        if (term.length == 0) {
          this.pagina = 0;
          this.obtenerUsuarios();
        }else if(term.length > 2){
          this.obtenerUsuarios();
        }
      });
  }

  obtenerUsuarios(paginaActual?: number) {
    this.pagina = paginaActual == null ? 0 : paginaActual;
    this.spinner.isRunning = true;
    this.usuarioService.listado(this.pagina, this.cantidadPorPagina, this.query.value ? this.query.value : "").subscribe(result => {
      this.spinner.isRunning = false;
      result.usuarios.forEach((u)=>{
        u.roles.forEach((r) => {
          r.name = result.roles.find((rol) => rol.id == r.id).name;
        })
      })
      this.listado = result;
      if (this.listado && this.listado.total > 0) {        
        this.paginas = Math.floor((this.listado.total + this.cantidadPorPagina - 1) / this.cantidadPorPagina);
      }
    });
  }

  anterior() {
    this.obtenerUsuarios(this.pagina - 1);
  }

  siguiente() {
    this.obtenerUsuarios(this.pagina + 1);
  }

  buscar() {
    this.pagina = 0;
    this.obtenerUsuarios();
  }

  formatRol(id: string) {
    var rol = this.listado.roles.filter(x => x.id == id)[0];
    if (rol) {
      return rol.name;
    }

    return null;
  }

  showDialog(usuario: UsuarioViewModel) {
    this.usuario = usuario;
    this.display = true;
  }

  eliminar() {
    this.display = false;
    this.spinner.isRunning = true;
    this.usuarioService.eliminar(this.usuario.id).subscribe(result => {
      this.alert.visible = true;
      this.alert.titulo = "Eliminar usuario";
      if (result.status == 204) {
        this.alert.tipo = "success"
        this.alert.mensaje = `El usuario ${this.usuario.userName} se ha eliminado correctamente`
      } else {
        this.alert.tipo = "danger"
        this.alert.mensaje = "El usuario no se ha podido eliminar. Por favor vuelva a intentarlo."
      }
      this.alertComponent.setType(this.alert.tipo);
      this.listado.usuarios = this.listado.usuarios.filter(u => {
        return u.id != this.usuario.id
      });
      this.usuario = null;      
      this.spinner.isRunning = false;
    }, error => {      
      this.spinner.isRunning = false;
      this.alert.visible = true;
      this.alert.titulo = "Eliminar usuario";
      this.alert.tipo = "danger"
      this.alertComponent.setType(this.alert.tipo);
      this.alert.mensaje = "El usuario no se ha podido eliminar. Por favor vuelva a intentarlo."
      
      
    })
  }

  editar(usuario:UsuarioViewModel){
    this.usuarioService.setUsuario(usuario);
    this.router.navigate(['dashboard/usuarios/editar'])
  }

  paginate(event) {    
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.obtenerUsuarios(event.page);
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/usuarios/usuarios.component.ts